import api from 'api/api'
import { toast } from 'react-toastify'
import { downloadBase64File } from 'utils/donwload-base64-file'
import { FILE_TYPE } from 'constants/file'

export const GET_COMMISSIONS = '[COMMISSIONS] GET COMMISSIONS'
export const GET_COMMISSION_DETAIL = '[COMMISSIONS] GET COMMISSION DETAIL'
export const PAY_COMMISSION = '[COMMISSIONS] PAY COMMISSION'
export const GET_COMMISSIONS_REPORT = '[COMMISSIONS] GET COMMISSIONS REPORT'
export const DOWNLOADING_COMMISSION_REPORT = '[COMMISSIONS] DOWNLOADING COMMISSION REPORT'

export function getCommissionsAction(filters = {}) {
  const request = api.get('/comisiones', { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_COMMISSIONS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_COMMISSIONS, payload: { ...response.data.data } })
    }).catch((error) => {
      console.log(GET_COMMISSIONS, error)
    }).finally(() => {
      dispatch({ type: GET_COMMISSIONS, payload: { loading: false } })
    })
  }
}

export function payCommissionAction(commissionId, data) {
  const request = api.post(`/comisiones/${commissionId}/pagar`, data)
  return (dispatch) => {
    dispatch({ type: PAY_COMMISSION, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: PAY_COMMISSION, payload: { saved: true } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(PAY_COMMISSION, error)
    }).finally(() => {
      dispatch({ type: PAY_COMMISSION, payload: { saving: false } })
    })
  }
}

export function getCommissionsReport(params = {}) {
  const request = api.get('/comisiones/reporte', { params })
  return (dispatch) => {
    dispatch({ type: GET_COMMISSIONS_REPORT, payload: { loading: true } })
    request.then((response) => {
      if (response.data.status !== 200) {
        toast.error(response.data.message || 'Error al obtener el reporte')
        dispatch({ type: GET_COMMISSIONS_REPORT, payload: { data: null } })
        return
      }
      dispatch({ type: GET_COMMISSIONS_REPORT, payload: { data: response.data.data } })
    }).catch((error) => {
      toast.error('Error de conexión al obtener el reporte')
      dispatch({ type: GET_COMMISSIONS_REPORT, payload: { data: null } })
      console.log(GET_COMMISSIONS_REPORT, error)
    }).finally(() => {
      dispatch({ type: GET_COMMISSIONS_REPORT, payload: { loading: false } })
    })
  }
}

export function downloadCommissionReportPdf(params = {}) {
  const request = api.get('/comisiones/pdf-reporte', { params })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_COMMISSION_REPORT, payload: true })
    request.then((response) => {
      downloadBase64File({
        filename: response.data.nombre,
        fileType: FILE_TYPE.PDF,
        file: response.data.archivo,
      })
      toast.success('Se descargó el PDF.')
      dispatch({ type: DOWNLOADING_COMMISSION_REPORT, payload: false })
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_COMMISSION_REPORT, payload: false })
      toast.error('Algo salió mal. No se pudo descargar el PDF.')
      console.error(error)
    })
  }
}

export function downloadCommissionReportExcel(params = {}) {
  const request = api.get('/comisiones/excel-reporte', { params })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_COMMISSION_REPORT, payload: true })
    request.then((response) => {
      downloadBase64File({
        filename: response.data.nombre,
        fileType: FILE_TYPE.EXCEL,
        file: response.data.archivo,
      })
      toast.success('Se descargó el Excel.')
      dispatch({ type: DOWNLOADING_COMMISSION_REPORT, payload: false })
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_COMMISSION_REPORT, payload: false })
      toast.error('Algo salió mal. No se pudo descargar el Excel.')
      console.error(error)
    })
  }
}

export function getCommissionDetailAction(commissionId) {
  const request = api.get(`/comisiones/${commissionId}/detalle`)
  return (dispatch) => {
    dispatch({ type: GET_COMMISSION_DETAIL, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: GET_COMMISSION_DETAIL, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_COMMISSION_DETAIL, error)
    }).finally(() => {
      dispatch({ type: GET_COMMISSION_DETAIL, payload: { loading: false } })
    })
  }
}
